import _forEach from 'lodash/forEach';
import _isUndefined from 'lodash/isUndefined';
import _reduce from 'lodash/reduce';
import _get from 'lodash/get';
import _sortBy from 'lodash/sortBy';
import _toArray from 'lodash/toArray';

/**
 * @private
 * @class
 *
 * @description
 * Все функции для работы с деревом
 */
var InstanceTree = function(tree) {
  var self = this;

  self.tree = tree;
  // Кэш для результатов getLevel
  self._levelCache = new Map();

  return self;
};

/**
 * @private
 * Получаем корень дерева вариантов
 */
InstanceTree.prototype._getTree = function() {
  var self = this;
  var _tree;

  if (!self.tree) {
    self.tree = {};
  }

  _tree = self.tree;

  return _tree;
};

/**
 * @param {number} level - номер уровня, откуда забираем значения
 * Кэширует результаты для оптимизации повторных вызовов
 */
InstanceTree.prototype.getLevel = function(level, selectedOptions) {
  var self = this;
  var cacheKey = level + ':' + JSON.stringify(selectedOptions || {});
  var _leaf = null;

  if (self._levelCache.has(cacheKey)) {
    return self._levelCache.get(cacheKey);
  }

  _leaf = self._getTree();

  //console.log('InstanceTree: getLevel: selectedOptions', selectedOptions);
  _forEach(selectedOptions, function(_selected, option_level) {
    if (option_level == level || _isUndefined(_selected)) {
      return false;
    }
    _leaf = _leaf[_selected].tree;
  });
  //console.log('InstanceTree: getLevel: _leaf: ', _leaf);

  _leaf = _sortBy(_toArray(_leaf), 'position');

  self._levelCache.set(cacheKey, _leaf);

  return _leaf;
};

/**
 *
 */
InstanceTree.prototype.isLeaf = function(_selectedOptions) {
  var self = this;
  var _isLeaf = false;
  var _path;

  _path = _reduce(_selectedOptions, function(__path, _selected) {
    return __path += 'tree[' + _selected + ']';
  }, '');
  //console.log('InstanceTree: isLeaf: _path: ', _path);

  _isLeaf = _get(self, _path);
  //console.log('InstanceTree: isLeaf: _isLeaf: ', _isLeaf);

  return _isLeaf;
};

/**
 *
 */
InstanceTree.prototype.getVariant = function(_selectedOptions) {
  var self = this;
  var variant = self.isLeaf(_selectedOptions);

  return variant;
};

export default InstanceTree;
